import { useState } from "react";

import {
  LandingBackdrop,
  LandingPines,
} from "@/components/landing/LandingBackdrop";
import { LandingFloorSlot } from "@/components/landing/LandingFloorSlot";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { LandingHero } from "@/components/landing/LandingHero";
import { LandingModes } from "@/components/landing/LandingModes";
import { LandingNarrator } from "@/components/landing/LandingNarrator";
import {
  LandingClosing,
  LandingFaq,
  LandingLayers,
  LandingTrust,
} from "@/components/landing/LandingSections";
import {
  LandingAudiences,
  LandingFriction,
  LandingHowItWorks,
} from "@/components/landing/LandingStory";

/**
 * The face of the root domain.
 *
 * It says what the place is, lets a visitor press a room before deciding about
 * one, and sends them into the app on the same origin (#942). Every word is
 * already in the catalogue, so the landing is read in the visitor's language
 * like everything else, and every door out of it is an ordinary path — the app
 * is not embedded here, and going to it is a navigation the visitor can see in
 * the address bar.
 *
 * The one thing that does happen here is the demo, and it happens in place, in
 * the first screen, whichever button asked for it: there is no use asking
 * somebody to decide about a room they have to sign up to see (#615).
 */
const Landing = () => {
  const [demo, setDemo] = useState(false);
  const startDemo = () => {
    setDemo(true);
    document.getElementById("top")?.scrollIntoView({ block: "start" });
  };

  return (
    <main className="relative isolate min-h-svh overflow-x-clip bg-background text-foreground">
      <LandingBackdrop />
      <LandingHeader />
      <LandingHero started={demo} onDemo={startDemo} />
      <LandingPines />
      <LandingFriction />
      <LandingFloorSlot />
      <LandingHowItWorks />
      <LandingAudiences />
      <LandingModes />
      <LandingLayers />
      <LandingNarrator />
      <LandingTrust />
      <LandingFaq />
      <LandingClosing onDemo={startDemo} />
      <LandingFooter />
    </main>
  );
};

export default Landing;
